import u from 'updeep';
import { handleActions } from 'redux-actions';
import * as actions from './userActions';
import * as bookActions from './bookActions';
import { receiveCreateReadingList } from './readingListsActions';

import { loginPolicy } from '../lib/policymanager/index'

const initialState = {
  isLoggedIn: false,
  isFetchingMe: false,
  isFetchingLogout: false,
  profile: {
    roles: [],
    bookshelf: {
      books: []
    }
  },
  languageOptions: [],
  isFetchingLists: false,
  isDeletingList: false,
  lists: [],
  language: 'en',
  offlinePopUpStatusUpdated: false,
  userFeedbackPopUpStatusUpdated: false,
  isAuthModalVisible: false,
  userAuthStages: '',
  organisations: [],
  isFetchingOrganisations: false,
  stage: '',
  resetPasswordToken: '',
  hideClose: false,
  isConsentGiven: false,
  createdAt: null,
  isFetchingNotifications: false,
  activeLink: '',
  menuSelected: '',
  isBottomMenuSelected: '',
  isUploadingUserProfile: false,
  isUserProfileModalVisible: false,
  isFetchingTags: false,
  autoCompleteData: [],
  isResendingOTP: false,
  isDonateModalVisible: false,
  isFetchingCountryDetails: false,
  isFetchingOrgnanisationNames: false,
  isFetchingAutoSuggestions: false,
  autoSuggestions: [],
  langSuggestions: [],
  isUserModalSeen: false,
  showFlp: false,
  isCbseRegisterModalVisible: false,
  status: null,
  isRegistering: false,
  isFetchingStaticDataCbse: false,
  staticDataCbse: {},
  platformNotifications: [],
  isCampaignRegisterModalVisible: false,
  isFromFlp: false,
  flpGrade: 1
};

export default handleActions({
  [actions.fetchNotifications]: (state, action) => u({
    isFetchingNotifications: true
  }, state),

  [actions.receiveNotifications]: (state, action) => u({
    isFetchingNotifications: false
  }, state),

  [actions.fetchNotificationsError]: (state, action) => u({
    isFetchingNotifications: false
  }, state),

  [actions.fetchPlatformNotifications]: (state, action) => u({
  }, state),

  [actions.receivePlatformNotifications]: (state, action) => u({
    platformNotifications: action.payload.platformNotifications
  }, state),

  [actions.fetchPlatformNotificationsError]: (state, action) => u({
    platformNotifications: []
  }, state),

  [actions.markAllNotificationsAsRead]: (state, action) => u({}, state),

  [actions.markAllNotificationsAsReadResponse]: (state, action) => u({
    platformNotifications: []
  }, state),

  [actions.markAllNotificationsAsReadError]: (state, action) => {
    return u({}, state);
  },

  [actions.markOneNotificationsAsRead]: (state, action) => u({}, state),

  [actions.markOneNotificationsAsReadResponse]: (state, action) => {
    return u({
    platformNotifications: state.platformNotifications.filter(notif => notif.id !== action.payload.notif_id)
  }, state);},

  [actions.markOneNotificationsAsReadError]: (state, action) => {
    console.log("Error occurred while marking this notification as read.");
    return u({}, state);
  },

  [actions.fetchMe]: (state, action) => u({
    isFetchingMe: true
  }, state),
  
  [actions.receiveMe]: (state, action) => {
    if (process.env.REACT_APP_FEATURE_MANDATORY_LOGIN) {
      loginPolicy.setIsLoggedIn(action.payload.profile.isLoggedIn);
    }
    return u({
        isFetchingMe: false,
        isLoggedIn: action.payload.profile.isLoggedIn,
        createdAt: action.payload.profile.createdAt,
        isConsentGiven: action.payload.profile.consentFlag,
        profile: action.payload.profile
      }, state)
  },

  [actions.fetchMeError]: (state, _) => u({
    isFetchingMe: false
  }, state),

  [actions.fetchLogout]: (state, action) => u({
    isFetchingLogout: true
  }, state),

  [actions.receiveLogout]: (state, action) => u({
    isFetchingLogout: false,
    isLoggedIn: false
  }, state),

  [actions.fetchUserLists]: (state, action) => u({
    isFetchingLists: true
  }, state),

  [actions.receiveUserLists]: (state, action) => u({
    isFetchingLists: false,
    lists: action.payload.lists
  }, state),

  [actions.fetchUserListsError]: (state, action) => u({
    isFetchingLists: false,
  }, state),

  [actions.deleteUserList]: (state, action) => u({
    isDeletingList: true
  }, state),

  [actions.receiveDeleteUserList]: (state, action) => {
    return u({
      isDeletingList: false,
      lists: u.reject(value => value.id.toString() === action.payload.listId),
    }, state)
  },

  [receiveCreateReadingList]: (state, action) => u({
    lists: state.lists.concat(action.payload.readingList)
  }, state),


  [actions.receiveOfflineChangePopUpStatus]: (state, action) => u({
    offlinePopUpStatusUpdated: true
  }, state),

  [actions.receiveUserFeedbackModalStatus]: (state, action) => u({
    userFeedbackPopUpStatusUpdated: true
  }, state),

  [actions.receiveChangeLanguage]: (state, action) => u({
    language: action.payload.newLanguage
  }, state),

  [actions.openAuthModal]: (state, action) => u({
    isAuthModalVisible: true,
    stage: action.payload ? action.payload.stage : '',
    resetPasswordToken: action.payload ? action.payload.resetPasswordToken : '',
    hideClose: action.payload ? action.payload.hideClose : false
  }, state),

  [actions.closeAuthModal]: (state, action) => u({
    isAuthModalVisible: false,
    stage: '',
    resetPasswordToken: ''
  }, state),

  [actions.fetchEmailStatus]: (state, action) => u({
    isLoadingNext: true
  }, state),

  [actions.receiveEmailStatus]: (state, action) => u({
    isLoadingNext: false
  }, state),

  [actions.fetchLogin]: (state, action) => u({
    isLoadingNext: true
  }, state),

  [actions.receiveLogin]: (state, action) => u({
    isLoadingNext: false
  }, state),

  [actions.fetchLoginError]: (state, action) => u({
    isLoadingNext: false
  }, state),

  [actions.fetchLanguageOptions]: (state, action) => u({
    isLoadingNext: true
  }, state),

  [actions.receiveLanguageOptions]: (state, action) => u({
    isLoadingNext: false,
    languageOptions: action.payload.queryValues
  }, state),

  [actions.fetchOrganisationsOptions]: (state, action) => u({
    isFetchingOrganisations: true
  }, state),

  [actions.receiveOrganisationsOptions]: (state, action) => {
    const organisations = action.payload.data.map(organisation => {
      return {
        ...organisation,
        name: organisation.name ?`${organisation.name}, ${organisation.country}` : ``,
        queryValue: organisation.name||``
      }
    })
    return u({
      isFetchingOrganisations: false,
      organisations: organisations
    }, state)
  },

  [actions.fetchSignup]: (state, action) => u({
    isLoadingNext: true
  }, state),

  [actions.receiveSignup]: (state, action) => u({
    isLoadingNext: false
  }, state),

  [actions.fetchSignupError]: (state, action) => u({
    isLoadingNext: false
  }, state),

  [actions.fetchResetPassword]: (state, action) => u({
    isLoadingNext: true
  }, state),

  [actions.receiveResetPassword]: (state, action) => u({
    isLoadingNext: false
  }, state),

  [actions.fetchResetPasswordError]: (state, action) => u({
    isLoadingNext: false
  }, state),

  [actions.fetchResendConfirmationLink]: (state, action) => u({
    isLoadingNext: true
  }, state),

  [actions.receiveResendConfirmationLink]: (state, action) => u({
    isLoadingNext: false
  }, state),

  [actions.fetchResendConfirmationLinkError]: (state, action) => u({
    isLoadingNext: false
  }, state),

  [bookActions.addNewBookToBookshelf] : (state, action) => u({
    isFetchingLists: true,
  }, state),

  [bookActions.receiveAddNewBookToBookshelf]: (state, action) => {
    return u({
    isFetchingLists: false,
    lists: action.payload.lists.stories
  }, state)},

  [bookActions.addBookshelf] : (state, action) => u({
    isFetchingLists: true,
  }, state),

  [bookActions.receiveAddBookshelf]: (state, action) => u({
    isFetchingLists: false,
    lists: action.payload.lists.stories
  }, state),

  [bookActions.removeFromBookshelf] : (state, action) => u({
    isFetchingLists: true,
  }, state),

  [bookActions.receiveRemoveFromBookshelf]: (state, action) => {
    return u({
      isFetchingLists: false,
      lists: action.payload.lists.stories
    }, state);
  },

  [actions.receiveupdateConsent]: (state, action) => u({
    isConsentGiven: true
  }, state),

  [actions.updateActiveDropdownLink]: (state, action) => u({
      activeLink: action.payload,
    }, state), 

  [actions.updateActiveMenuSelected]: (state, action) => u({
      menuSelected: action.payload,
    }, state), 

  [actions.bottomMenuSelected]: (state, action) => u({
    isBottomMenuSelected: action.payload,
  }, state),

  [actions.postUserProfile]: (state, action) => u({
    isUploadingUserProfile: true
  }, state),

  [actions.receivePostUserProfile]: (state, action) => u({
    isUploadingUserProfile: false,
    isUserModalSeen: action.payload.ok
  }, state),

  [actions.postUserProfileError]: (state, action) => u({
    isUploadingUserProfile: false,
  }, state),

  [actions.postUserProfileData]: (state, action) => u({
    isUpdatingUserProfile: true
  }, state),

  [actions.receivePostUserProfileData]: (state, action) => u({
    isUpdatingUserProfile: false,
  }, state),

  [actions.postUserProfileErrorData]: (state, action) => u({
    isUpdatingUserProfile: false,
  }, state),

  [actions.postChangePassword]: (state, action) => u({
    isChangePassword: true
  }, state),

  [actions.receiveChangePassword]: (state, action) => u({
    isChangePassword: false,
  }, state),

  [actions.postChangePasswordError]: (state, action) => u({
    isChangePassword: false,
  }, state),

  [actions.postOrganisationDetails]: (state, action) => u({
    isSaveOrganisationDetails: true
  }, state),

  [actions.receiveOrganisationDetails]: (state, action) => u({
    isSaveOrganisationDetails: false,
  }, state),

  [actions.postOrganisationDetailsError]: (state, action) => u({
    isSaveOrganisationDetails: false,
  }, state),

  [actions.openUserProfileModal]: (state, action) => u({
    isUserProfileModalVisible: true,
    showFlp: action.payload ? action.payload.showFlp : false,
    isFromFlp: action.payload ? action.payload.isFromFlp : false,
    flpGrade: action.payload ? action.payload.flpGrade : false,
  }, state),

  [actions.closeUserProfileModal]: (state, action) => u({
    isUserProfileModalVisible: false,
  }, state), 

  [actions.fetchAutoCompleteUserData]: (state, action) => u({
    isFetchingTags: true
  }, state),

  [actions.receiveAutoCompleteUserData]: (state, action) => u({
      isFetchingTags: false,
      autoCompleteData: action.payload.data
   }, state) ,

  [actions.fetchAutoCompleteUserDataError]: (state, action) => u({
    isFetchingTags: false
  }, state),

  [actions.fetchOrganisationCountryDetails]: (state, action) => u({
    isFetchingCountryDetails: true
  }, state),

  [actions.receiveOrganisationCountryDetails]: (state, action) => u({
    isFetchingCountryDetails: false,
    autoCompleteData: action.payload.data
   }, state) ,

  [actions.fetchOrganisationDetailsError]: (state, action) => u({
    isFetchiisFetchingCountryDetailsngTags: false
  }, state),

  [actions.fetchOrganisationNames]: (state, action) => u({
    isFetchingOrgnanisationNames: true
  }, state),

  [actions.receiveOrganisationNames]: (state, action) => u({
    isFetchingOrgnanisationNames: false,
    autoCompleteData: action.payload.data
   }, state) ,

  [actions.fetchOrganisationNameError]: (state, action) => u({
    isFetchingOrgnanisationNames: false
  }, state),

  [actions.fetchOTPSignup]: (state, action) => u({
    isLoadingNext: true
  }, state),

  [actions.receiveOTPSignup]: (state, action) => u({
    isLoadingNext: false
  }, state),

  [actions.fetchOTPSignupError]: (state, action) => u({
    isLoadingNext: false
  }, state),

  [actions.fetchResendOTP]: (state, action) => u({
    isResendingOTP: true
  }, state),

  [actions.receiveResendOTP]: (state, action) => u({
    isResendingOTP: false
  }, state),

  [actions.fetchResendOTPError]: (state, action) => u({
    isResendingOTP: false
  }, state),

  [actions.fetchPhoneNumberStatus]: (state, action) => u({
    isLoadingNext: true
  }, state),

  [actions.receivePhoneNumberStatus]: (state, action) => u({
    isLoadingNext: false
  }, state),

  [actions.fetchPhoneNumberStatusError]: (state, action) => u({
    isLoadingNext: false
  }, state),

  [actions.fetchOTPLogin]: (state, action) => u({
    isLoadingNext: true
  }, state),

  [actions.receiveOTPLogin]: (state, action) => u({
    isLoadingNext: false
  }, state),

  [actions.fetchOTPLoginError]: (state, action) => u({
    isLoadingNext: false
  }, state),

  [actions.fetchOTP]: (state, action) => u({
    isLoadingNext: true
  }, state),

  [actions.receiveOTP]: (state, action) => u({
    isLoadingNext: false
  }, state),

  [actions.fetchOTPError]: (state, action) => u({
    isLoadingNext: false
  }, state),

  [actions.openDonateModal]: (state, action) => u({
    isDonateModalVisible: true
  }, state),

  [actions.closeDonateModal]: (state, action) => u({
    isDonateModalVisible: false
  }, state),
  
  [actions.fetchAutoSuggestions]: (state, action) => u({
    isFetchingAutoSuggestions: true
  }, state),
  
  [actions.receiveAutoSuggestions]: (state, action) => {
    return u({
      isFetchingAutoSuggestions: false,
      autoSuggestions: !action.payload.showLangSuggestion && action.payload.autoSuggestions,
      langSuggestions: action.payload.showLangSuggestion && action.payload.autoSuggestions,
      query: action.payload.query
    }, state)
  },

  [actions.fetchAutoSuggestionsError]: (state, action) => u({
    isFetchingAutoSuggestions: false
  }, state),

  [actions.openCbseRegisterModal]: (state, action) => u({
    isCbseRegisterModalVisible: true,
    status: action.payload
  }, state),

  [actions.closeCbseRegisterModal]: (state, action) => u({
    isCbseRegisterModalVisible: false,
    status: null
  }, state),

  [actions.fetchRegisterCbseBookshelf] : (state, action) => u({
    isRegistering: true
  }, state),

  [actions.receiveRegisterCbseBookshelf] : (state, action) => u({
    isRegistering: false
  }, state),

  [actions.fetchStaticDataCbse] : (state, action) => u({
    isFetchingStaticDataCbse: true
  }, state),

  [actions.receiveStaticDataCbse] : (state, action) => u({
    isFetchingStaticDataCbse: false,
    staticDataCbse: action.payload.data
  }, state),
  
  [actions.openCampaignRegisterModal]: (state, action) => u({
    isCampaignRegisterModalVisible: true,
    status: action.payload
  }, state),

  [actions.closeCampaignRegisterModal]: (state, action) => u({
    isCampaignRegisterModalVisible: false,
    status: null
  }, state),

  [actions.fetchRegisterCampaignBookshelf] : (state, action) => u({
    isRegistering: true
  }, state),

  [actions.receiveRegisterCampaignBookshelf] : (state, action) => u({
    isRegistering: false
  }, state),

  [actions.fetchCampaignCertificate] : (state, action) => u({
    isFetchingStaticDataCampaign: true
  }, state),

  [actions.receiveCampaignCertificate] : (state, action) => u({
    isFetchingStaticDataCampaign: false,
    staticDataCampaign: action.payload.data
  }, state),
  
  [actions.fetchUserCampaignData] : (state, action) => u({
    isFetchingStaticDataCbse: true
  }, state),

  [actions.receiveUserCampaignData] : (state, action) => u({
    isFetchingStaticDataCbse: false,
    staticDataCbse: action.payload.data
  }, state),

}, initialState);




// WEBPACK FOOTER //
// ./src/redux/userReducer.js